import { Component } from 'preact';
import axios from 'axios';
import ListEnhancedContent from '../../util/listEnhancedContent'

export default class Content extends Component {

		constructor() {
			super();
			// set initial time:
			this.state = { currentItemECData: 'loading' };
		}

		componentWillMount(){
			let {urlParameters} = this.props
			let retailer = urlParameters && urlParameters.retailer  ? urlParameters  : 'walmart'
			let productId = urlParameters && urlParameters.productId
			let mobileHide = urlParameters && urlParameters.mobileHide ? urlParameters.mobileHide : false

			if ( retailer !== 'walmart' ){
				//get retailer map to find correct item id
			}

			//console.log('productId: ' + productId)

	    let richContentPromiseArray =[]
	    //get all enhance content for current item page

	    axios.get('https://columbus-c4de8.firebaseio.com/products/' + productId + '.json').then( (response) => {

	      let richContentList = response && response.data && response.data.richContentList
	      richContentList = richContentList ? richContentList : []

	      if ( !richContentList ){
	        throw new Error('No rich content list for product Id: ' + productId)
	      }

	      richContentList.forEach( currentRichItem => {
	        richContentPromiseArray.push( axios.get('https://columbus-c4de8.firebaseio.com/richContent/' + currentRichItem.richId + '.json') )
	      })

	      return Promise.all(richContentPromiseArray)

	    }).then( results => {


	      let currentItemECData = results.map( current =>
	  				current.data
	  		)

	      this.setState({currentItemECData, initialPageItemId: productId, errorMessage: null, mobileHide})

	    }).catch( err => {
	      console.error(err.message)
	      this.setState({errorMessage: err.message})
	    });

		}

		render(){

			if (this.state.errorMessage ){
				return null
			} else if (this.state.currentItemECData === 'loading'){
				return null
			}


			return (
				<ListEnhancedContent {...this.state} website={this.props.website} />
			);

		}

}



// WEBPACK FOOTER //
// ./components/requestType/product/product.js